import {
  Box,
  Button,
  Container,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { useContext, useMemo, useState } from "react";

import SourceMapDetailsComponent from "../sourcemap-details/sourcemap-details.component";
import useReportCoreApi from "../../../useReportCoreApi";
import LoadingDialogComponent from "../../../../../../shared/components/loading-dialog/loading-dialog.component";
import useLoader from "../../../../../../shared/components/loading-dialog/useLoader.hook";
import { CreateSourceMapContext } from "../../../../../../shared/context/create-sourcemap/create-sourcemap-context";
import CreateSourceMapService from "../../create-sourcemap.component.service";
import IDataBody from "../../../../../../shared/contracts/IDataBody";

interface IProps {
  data: IDataBody[];
  onApply: () => void;
}

export default function CreateSourceMapStepperComponent({
  onApply = () => {},
}: IProps) {
  const { saveSourceMapDetails } = useReportCoreApi();
  const { createSourceMapForm } = useContext(CreateSourceMapContext)!;

  const saveSourceMapLoader = useLoader({
    loaderName: "Save SourceMap",
    loadAsync: () =>
      saveSourceMapDetails(
        CreateSourceMapService.getSaveSourceMapDetailsBody(createSourceMapForm),
        {
          doIf: () => saveSourceMapLoader.isNotLoading, //TODO hasValidSaveChanges && saveReportLoader.isNotLoading,
          doBefore: () => {
            saveSourceMapLoader.SET_LOADING("Saving SourceMap...");
          },
          onFulfilled: (data) => {
            saveSourceMapLoader.SET_SUCCESS("Success.!");
            onApply();
          },
          onException: saveSourceMapLoader.SET_EXCEPTION,
        }
      ),
  });

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <></>

        <>
          <Box
            component={"form"}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              minHeight: "calc(20vh)",
              padding: "1%",
            }}
          >
            {<SourceMapDetailsComponent />}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />

            <Box sx={{ display: "flex", flexDirection: "row", pt: 0 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={() => saveSourceMapLoader.loadAsync()}>
                Submit
              </Button>
            </Box>
          </Box>
        </>
      </Box>
      {<LoadingDialogComponent loaderHook={saveSourceMapLoader} />}
    </>
  );
}
